import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Table from "../../../../core/pagination/datatable";
import { Avatar, Spin, Tag } from "antd";
import { BASE_CRM_URL } from "../../../components/config/config";
import Swal from "sweetalert2";
import axios from "axios";

const LeadsTable = () => {
  const statusColors = {
    New: "green",
    "Follow Up": "blue",
    "Quote Sent": "gold",
    "No Response": "orange",
    "No Answer": "red",
    Customer: "purple",
    Default: "default",
  };

  const sourceColors = {
    website: "blue",
    referral: "green",
    facebook: "cyan",
    imdiamart: "purple",
    instagram: "magenta",
    whatsapp: "green",
    call: "orange",
    google: "red",
    default: "default",
  };

  const [leadsData, setLeadsData] = useState([]);
  const [sorceData, setSorceData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  // const [leadsCountData, setLeadsCountData] = useState([]);
  const [statusCards, setStatusCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sourceLoading, setSourceLoading] = useState(false);
  const [statusLoading, setStatusLoading] = useState(false);
  // const [leadsCountLoading, setLeadsCountLoading] = useState(false);
  // const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [selectedSource, setSelectedSource] = useState(0);

  const columns = [
    {
      title: "Lead",
      dataIndex: "name",
      width: 260,
      key: "name",
      render: (_, record) => {
        const initials = record.name
          ?.split(" ")
          .slice(0, 2)
          .map((x) => x[0])
          .join("")
          .toUpperCase();

        const avatarColor =
          statusColors[record.StatusName] === "green"
            ? "#52c41a"
            : statusColors[record.StatusName] === "blue"
              ? "#1677ff"
              : statusColors[record.StatusName] === "orange"
                ? "#fa8c16"
                : statusColors[record.StatusName] === "red"
                  ? "#ff4d4f"
                  : statusColors[record.StatusName] === "purple"
                    ? "#722ed1"
                    : "#6c757d";

        return (
          <div className="d-flex align-items-start">
            <div className="position-relative">
              <Avatar
                size={39}
                style={{
                  backgroundColor: avatarColor,
                  fontWeight: 700,
                  fontSize: 17,
                }}
              >
                {initials}
              </Avatar>

              <span
                className={`position-absolute bottom-0 end-0 border border-white rounded-circle ${
                  record.active ? "bg-success" : "bg-danger"
                }`}
                style={{
                  width: 11,
                  height: 11,
                }}
              />
            </div>

            <Link to={`/crm/viewleads/${record.id}`} className="ms-3">
              <div className="fw-semibold" title={record.name}>
                {record.name?.length > 20
                  ? `${record.name.substring(0, 20)}...`
                  : record.name}
              </div>

              <small className="text-muted" title={record.company}>
                <i className="fa-solid fa-building text-info me-2"></i>
                {record.company?.length > 20
                  ? `${record.company.substring(0, 20)}...`
                  : record.company}
              </small>
            </Link>
          </div>
        );
      },
    },

    {
      title: "Contact",
      dataIndex: "email",
      width: 240,
      render: (_, record) => (
        <>
          <div>
            <i className="fa-regular fa-envelope text-primary me-2"></i>
            <a href={`mailto:${record.email}`} className="text-decoration-none">
              {record.email}
            </a>
          </div>

          <small className="text-muted d-flex align-items-center mt-1">
            <a
              href={`tel:${record.phonenumber}`}
              className="text-decoration-none text-muted"
            >
              <i className="fa-solid fa-phone text-success me-2"></i>
              <span>{record.phonenumber}</span>
            </a>

            <a
              href={`https://wa.me/${record.phonenumber?.replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="ms-3"
              title="Chat on WhatsApp"
            >
              <i
                className="fa-brands fa-whatsapp text-success"
                style={{ fontSize: "16px" }}
              ></i>
            </a>
          </small>
        </>
      ),
    },

    {
      title: "Source",
      dataIndex: "SourceName",
      width: 170,
      render: (text) => {
        const sourceKey = text?.trim().toLowerCase();

        return (
          <Tag
            color={sourceColors[sourceKey] || sourceColors.default}
            bordered={false}
            style={{
              borderRadius: 20,
              padding: "4px 12px",
              fontWeight: 500,
            }}
          >
            <i className="fa-solid fa-bullseye me-2"></i>
            {text}
          </Tag>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "StatusName",
      width: 180,
      render: (text, record) => {
        const color =
          text === "New"
            ? "success"
            : text === "Follow Up"
              ? "primary"
              : text === "Quote Sent"
                ? "info"
                : text === "No Response"
                  ? "warning"
                  : text === "No Answer"
                    ? "danger"
                    : text === "Customer"
                      ? "secondary"
                      : "secondary";

        const handleStatusChange = (status) => {
          console.log(status, record);
        };

        return (
          <div className="dropdown">
            <span
              className={`badge bg-outline-${color}`}
              style={{ cursor: "pointer" }}
              data-bs-toggle="dropdown"
            >
              <i className="fa-solid fa-circle-dot me-2"></i>
              {text}
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </span>

            <ul className="dropdown-menu">
              {[
                "New",
                "Follow Up",
                "Quote Sent",
                "No Response",
                "No Answer",
                "Customer",
              ].map((status) => (
                <li key={status}>
                  <a
                    href="#"
                    className="dropdown-item"
                    onClick={() => handleStatusChange(status)}
                  >
                    {status}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        );
      },
    },
  ];

  //integration part

  const getLeads = async () => {
    setLoading(true);
    const userDetails = JSON.parse(
      sessionStorage.getItem("userDetails") || "{}",
    );

    try {
      const response = await axios.get(
        `${BASE_CRM_URL}leads/GetLeadsByStatus`,
        {
          params: {
            statusId: selectedStatus,
            sourceId: selectedSource,
            assignTo: userDetails?.staffid,
          },
        },
      );

      if (response.data.Status) {
        setLeadsData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No leads found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Leads API Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const getSourceDropDown = async () => {
    setSourceLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadSources`);

      if (response.data.Status) {
        setSorceData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No source data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("Source API Error:", error);
    } finally {
      setSourceLoading(false);
    }
  };

  const getStatusDropDown = async () => {
    setStatusLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadStatus`);

      if (response.data.Status) {
        setStatusData(response.data.ResultData || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No status data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("status API Error:", error);
    } finally {
      setStatusLoading(false);
    }
  };

  const getLeadsCount = async () => {
    // setLeadsCountLoading(true);

    try {
      const response = await axios.get(`${BASE_CRM_URL}leads/GetLeadCounts`);

      if (response.data.Status) {
        const dashboard = response.data.ResultData[0];
        // setLeadsCountData(response.data.ResultData || []);
        setStatusCards(dashboard.StatusWiseLeads || []);
      } else {
        Swal({
          title: "Warning",
          text: response.data.Message || "No leadcount data found.",
          icon: "warning",
          button: "OK",
        });
      }
    } catch (error) {
      console.error("leadcount API Error:", error);
    }
    // finally {
    //   setLeadsCountLoading(false);
    // }
  };
  console.log(statusData);
  useEffect(() => {
    getSourceDropDown();
    getStatusDropDown();
    getLeadsCount();
  }, []);

  useEffect(() => {
    getLeads();
  }, [selectedStatus, selectedSource]);

  const sorceOptions = [
    { value: 0, label: "All" },
    ...sorceData.map((sorce) => ({
      value: sorce.SourceId,
      label: sorce.SourceName,
    })),
  ];

  const statusOptions = [
    { value: 0, label: "All" },
    ...statusCards.map((status) => ({
      value: status.StatusId,
      label: status.StatusName,
    })),
  ];

  return (
    <div className="card table-list-card ">
      <div className="card-header d-flex align-items-center justify-content-between flex-wrap ">
        <div className="search-set"></div>
        <div className="d-flex table-dropdown my-xl-auto ">
          <div className="dropdown me-2" style={{ width: 150 }}>
            <Select
              placeholder="Status"
              options={statusOptions}
              value={statusOptions.find((x) => x.value === selectedStatus)}
              onChange={(option) => setSelectedStatus(option?.value ?? 0)}
              className="select2"
              loading={statusLoading}
            />
          </div>
          <div className="dropdown me-2" style={{ width: 150 }}>
            <Select
              placeholder="Source"
              options={sorceOptions}
              value={sorceOptions.find((x) => x.value === selectedSource)}
              onChange={(option) => setSelectedSource(option?.value ?? 0)}
              className="select2"
              loading={sourceLoading}
            />
          </div>
        </div>
      </div>

      <div className="card-body p-0">
        <div className="table-responsive">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "250px", // adjust height if needed
              }}
            >
              <Spin size="large" />
            </div>
          ) : (
            <Table columns={columns} dataSource={leadsData} />
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadsTable;
